import { AtomicBlockUtils, EditorState } from 'draft-js';
import { useState } from 'react';

import AttachmentsSelector from 'my-components/AttachmentsSelector';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

const YOUTUBE_REGEX = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;

const rootCss = ({ spacing }) => ({
  '.VE-dialogContent': { paddingBottom: spacing(3) },
  '.VE-button': { marginTop: spacing(2) },
});

export default function VideoEditor({ editorState, mode, onClose, onExited, onUpdateEditorState }) {
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [error, setError] = useState(false);

  const getYoutubeId = function (url) {
    const match = url && url.match(YOUTUBE_REGEX);
    return match && match[7].length === 11 ? match[7] : false;
  };

  const confirmVideo = function (params) {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('VIDEO', 'IMMUTABLE', { ...params, source: mode });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    let newEditorState;

    newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
    newEditorState = AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ');

    onUpdateEditorState(newEditorState);
    onClose();
    setYoutubeUrl('');
  };

  const confirmLibrary = function ({ id, urls }) {
    confirmVideo({ id, urls: { hls: urls.hls, original: urls.original, subtitles: urls.subtitles } });
  };
  const confirmYoutube = function () {
    const youtubeId = getYoutubeId(youtubeUrl);
    if (!youtubeId) {
      setError(true);
      return;
    }
    confirmVideo({ youtubeId });
  };

  const youtubeChange = function ({ target: { value } }) {
    setYoutubeUrl(value);
    error && setError(false);
  };

  return (
    <>
      <Dialog css={rootCss} onClose={onClose} open={mode === 'youtube'} slotProps={{ transition: { onExited } }}>
        <DialogTitle>Add Youtube Video</DialogTitle>
        <DialogContent className="VE-dialogContent">
          <TextField
            error={error}
            fullWidth
            helperText={error && 'Invalid URL'}
            label="Youtube URL"
            onChange={youtubeChange}
            value={youtubeUrl}
            variant="standard"
          />
          <Button className="VE-button" fullWidth onClick={confirmYoutube} variant="contained">
            Done
          </Button>
        </DialogContent>
      </Dialog>
      <AttachmentsSelector
        fileType="video"
        onClose={onClose}
        onExited={onExited}
        onSelect={confirmLibrary}
        open={mode === 'library'}
      />
    </>
  );
}
